import styled from "styled-components";

const StyledFormDateSelect = styled.div`
	width: 100%;

	&.sb-form-select {
		.ant-select-selector {
			background: ${({ theme }) => theme.colors.white};
			border-radius: 100px;
		}

		.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
			background: ${({ theme }) => theme.colors.white};
			border: 1px solid ${({ theme }) => theme.colors.iron};
			border-radius: 100px;
		}

		.ant-select-selection-item,
		.ant-select-selection-placeholder {
			padding: 8px 6px;
		}

		.ant-form-item-label {
			label {
				font-family: "DM Sans", sans-serif;
				font-style: normal;

				font-size: 14px;
				line-height: 16px;

				color: ${({ theme }) => theme.colors.trout};
			}
		}

		.ant-form-item-explain-error {
		}
	}
`;

export default StyledFormDateSelect;

